import './styles.scss';
import Button from '@/components/common/Button';

const SyncAccuracyModal = ({ isOpen, onClose, orphanedClusters }) => {
  if (!isOpen) return null;

  return (
    <div className="audit-modal-overlay" onClick={onClose}>
      <div className="audit-modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Synchronization Audit</h3>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          <p>The following industry clusters from your <strong>Demand</strong> dataset have no direct match in your <strong>Supply</strong> record:</p>
          {orphanedClusters && orphanedClusters.length > 0 ? (
            <ul className="orphan-list">
              {orphanedClusters.map((cluster, i) => (
                <li key={i}>{cluster}</li>
              ))}
            </ul>
          ) : (
            <div className="success-message">
              <span>✅</span> All clusters are perfectly synchronized!
            </div>
          )}
        </div>
        <div className="modal-footer">
          <Button variant="primary" onClick={onClose}>Acknowledge</Button>
        </div>
      </div>
    </div>
  );
};

export default SyncAccuracyModal;
